import { LogBox } from 'react-native';

// IMPORTANTE: este módulo deve ser importado ANTES de qualquer import de
// `expo-notifications`, pois o aviso de push remoto dispara no carregamento
// do módulo. Importar isto primeiro garante que o filtro já esteja ativo.
//
// Avisos inofensivos no Expo Go (push remoto foi removido no SDK 53 — usamos
// notificações LOCAIS, que continuam funcionando). Silencia o overlay vermelho.
LogBox.ignoreLogs([
  /expo-notifications/i,
  /Android Push notifications .* removed from Expo Go/i,
  /remote notifications.*Expo Go/i,
  /development build instead of Expo Go/i,
]);

export {};
